export const NumberKeyCodes = {
  BREAK: 3,
  BACKSPACE: 8,
  TAB: 9,
  CLEAR: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  HANGUL: 21,
  HANJA: 25,
  ESCAPE: 27,
  CONVERSION: 28,
  NON_CONVERSION: 29,
  SPACEBAR: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  SELECT: 41,
  PRINT: 42,
  EXECUTE: 43,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  HELP: 47,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  SEMICOLON: 58,
  EQUALS__SEMICOLON_FF: 59, // EQUALS__SEMICOLON-FF
  LESS_THAN: 60, // <
  EQUALS_FF: 61, // EQUALS-FF
  BETA: 63, // ß
  AT_FF: 64, // @-FF
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  WINDOWS_KEY__LEFT_COMMAND__SEARCH: 91, // WINDOWS_KEY__LEFT-COMMAND__SEARCH
  RIGHT_WINDOWS_KEY: 92,
  WINDOWS_MENU__RIGHT_COMMAND: 93,
  sleep: 95,
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105,
  MULTIPLY: 106,
  ADD: 107,
  NUMPAD_PERIOD_FF: 108,
  SUBTRACT: 109,
  DECIMAL_POINT: 110,
  DIVIDE: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145,
  CARET: 160, // ^
  EXCLAMATION_POINT: 161, // !
  ARABIC_SEMICOLON: 162, // ;
  HASH: 163, // #
  DOLLAR: 164, // $
  U_GRAVE: 165, // ù
  PAGE_BACKWARD: 166,
  PAGE_FORWARD: 167,
  REFRESH: 168,
  CLOSING_PAREN: 169,
  ASTERISK: 170, // *
  TILDE_ASTERISK: 171, // '~__*'
  HOME_KEY: 172,
  MINUS_FF__MUTE__UNMUTE: 173, // MINUS-FF__MUTE__UNMUTE
  DECREASE_VOLUME_LEVEL: 174,
  INCREASE_VOLUME_LEVEL: 175,
  NEXT: 176,
  PREVIOUS: 177,
  STOP: 178,
  PLAY__PAUSE: 179,
  EMAIL: 180,
  MUTE_FF__UNMUTE_FF: 181, // MUTE--FF__UNMUTE--FF
  DECREASE_VOLUME_LEVEL_FF: 182, // DECREASE_VOLUME_LEVEL-FF
  INCREASE_VOLUME_LEVEL_FF: 183, // INCREASE_VOLUME_LEVEL-FF
  SEMICOLON__Ñ: 186, // SEMICOLON--Ñ
  EQUAL_SIGN: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,
  FORWARD_SLASH: 191, // FORWARD_SLASH__ç
  GRAVE_ACCENT: 192, // grave accent / ñ / æ / ö
  QUESTION_MARK: 193, // ?, / or °
  NUMPAD_PERIOD_CH: 194, // NUMPAD_PERIOD-CH
  OPEN_BRACKET: 219,
  BACK_SLASH: 220,
  CLOSE_BRACKET: 221, // CLOSE_BRACKET__å
  SINGLE_QUOTE__ø__ä: 222, // SINGLE_QUOTE__ø__ä
  BACKTICK: 223, // `
  COMMAND_FF: 224, // COMMAND-FF
  ALTGR: 225,
  LEFT_BACK_SLASH: 226, // LEFT_BACK_SLASH
  GNOME_Compose_Key: 230, // GNOME Compose Key
  CEDILLA: 231, // ç
  XF86Forward: 233, // XF86Forward
  XF86Back: 234, // XF86Back
  non_conversion: 235, // non-conversion
  ALPHANUMERIC: 240,
  HIRAGANA_KATAKABA: 242,
  HALF_WIDTH__FULL_WIDTH: 243,
  KANJI: 244,
  UNLOCK_TRACKPAD_CH_ED: 251, // UNLOCK_TRACKPAD-CH-ED
  TOGGLE_TOUCHPAD: 255,
};
